import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  infoLabel: {
    marginBottom: theme.spacing(1)
  }
}));
